import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function ZihinselPerformansTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['zihinsel-performans-testi']} />;
}
